import { css } from "@stubhub/broadway-foundation/css";

export const container = css({
  display: "flex",
  flexDirection: "column",
  rowGap: "primitives.200",
  paddingBlockStart: "primitives.200",
  paddingBlockEnd: "primitives.200",
  paddingInlineStart: "primitives.200",
  paddingInlineEnd: "primitives.200",
  backgroundColor: "bg.surface",
  borderStartStartRadius: "element.default",
  borderStartEndRadius: "element.default",
  borderEndStartRadius: "element.default",
  borderEndEndRadius: "element.default",
  boxShadow: "floating",
});

export const spotifyPlayerHeight = css({
  height: "[84px]",
});

export const titleDiv = css({
  textStyle: "title.medium",
});

export const titleDivSmall = css({
  textStyle: "title.small",
});

export const genreTagWrapper = css({
  display: "flex",
  textTransform: "capitalize",
  textWrap: "nowrap",
  columnGap: "[5px]",
  rowGap: "[5px]",
  marginBlockStart: "primitives.50",
});

export const buttonWrapper = css({
  display: "flex",
  justifyContent: "center",
});
